import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { enterpriseStatusPageAdminRouter } from './tools/enterprise-status-page/routing/EnterpriseStatusPageRouter'
import { enterpriseStatusPageAccessControl } from './tools/enterprise-status-page/access-control/enterpriseStatusPageAccess.configuration'
import ENTERPRISE_STATUS_PAGE_EN_US from './tools/enterprise-status-page/translations/en-US.json'
import { caperBillingAdminRouter } from './tools/caper-billing/routing/CaperBillingRouter'
import { caperBillingAccessControl } from './tools/caper-billing/access-control/caperBillingAccess.configuration'
import CAPER_BILLING_EN_US from './tools/caper-billing/translations/en-US.json'

const EN_US = {
  ...ENTERPRISE_STATUS_PAGE_EN_US,
  ...CAPER_BILLING_EN_US,
  // @hygen:inject tool-translations
}

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'enterprise-solutions',
  totem: {
    tool: 'enterprise-solutions-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    admin: [enterpriseStatusPageAdminRouter, caperBillingAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Operations,
      subNavItems: [
        {
          route: 'app-admin-enterprise-status-page',
          subRoutes: [
            'app-admin-enterprise-status-page-create-incident',
            'app-admin-enterprise-status-page-incident-details',
            'app-admin-enterprise-status-page-user-groups',
          ],
          labelId: 'enterpriseStatusPageDomain.title',
          accessControl: enterpriseStatusPageAccessControl,
          positionNavV2: 1,
        },
        {
          route: 'app-admin-caper-billing',
          labelId: 'caperBillingDomain.title',
          accessControl: caperBillingAccessControl,
          positionNavV2: 2,
        },
      ],
    },
  ],
}

export default definition
